import { supabase } from '@/integrations/supabase/client';
import type { Supplier, SupplierProduct } from '@/types/database.types';

export const getSuppliers = async () => {
  const { data, error } = await supabase
    .from('suppliers')
    .select('*, supplier_products(*), supplier_categories(*)');
  
  if (error) throw error;
  
  return data;
};

export const getSupplierById = async (id: string) => {
  const { data, error } = await supabase
    .from('suppliers')
    .select('*, supplier_products(*), supplier_categories(*)')
    .eq('id', id)
    .single();
  
  if (error) throw error;
  
  return data;
};

export const createSupplier = async (supplier: Omit<Supplier, 'id' | 'created_at' | 'updated_at'>) => {
  const { data, error } = await supabase
    .from('suppliers')
    .insert(supplier)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const updateSupplier = async (id: string, supplier: Partial<Omit<Supplier, 'id' | 'created_at' | 'updated_at'>>) => {
  const { data, error } = await supabase
    .from('suppliers')
    .update(supplier)
    .eq('id', id)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const addSupplierProduct = async (supplierProduct: { 
  supplier_id: string; 
  product_name: string; 
  unit_price?: number | null;
}) => {
  const { data, error } = await supabase
    .from('supplier_products')
    .insert(supplierProduct)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const removeSupplierProduct = async (supplierId: string, productId: string) => {
  const { error } = await supabase
    .from('supplier_products')
    .delete()
    .eq('id', productId)
    .eq('supplier_id', supplierId);
  
  if (error) throw error;
  return { success: true };
};
